import styles from './Header.module.css';
import { Container, Row, Col, Button, Navbar, Nav, ButtonGroup, ListGroup, NavDropdown} from 'react-bootstrap';
import naija from '../../assets/icons/naija.png';
import arrow from '../../assets/icons/vec1.png';
import logo from '../../assets/imgs/logo.png';
import { Link} from 'react-router-dom';


export const Header = () =>{
    return <div>
        <Container fluid >
            <Row>
                <Col lg={12} sm={12} xs={12} md={12} className={`${styles.annTop}`}>
                    <Row  className={`fixed-top ${styles.LG}`}>
                    <Col lg={8} sm={12} xs={12} md={6} className={` me-lg-auto ms-lg-auto ${styles.LG}`}>
                        <p className={` ${styles.annText}`}>Announcements: Earn upto 10% for every user you bring to ULLWEB and 2.5% of all thier spend for 2 years</p>
                    </Col> 
                    <Col lg={3} sm={12} xs={12} md={6}>
                    <Button variant='outline-primary' size='md'  className={`${styles.btn1}`}>Get Started Free</Button>
                    </Col>

                    </Row>
                </Col>

                <Col lg={12} className={` ${styles.navh}`}>
                    <Navbar bg='white' expand='lg' className={`fixed-top bg-white ${styles.navbar}`}>
                        <Container className='bg-white'>
                            <Navbar.Brand className={`${styles.logo}`} as={Link} to='/'><img src={logo} alt='ullweb logo' /></Navbar.Brand>
                            <Navbar.Toggle aria-controls='navbarScroll' className={` ${styles.toggle}`}/>
                            <Navbar.Collapse id='navbarScroll' >
                                <Nav className={`me-lg-auto my-lg-0 my-2 ${styles.nav1}`} navbarScroll>
                                    <Nav.Link href='#howitworks' className={`${styles.navlink}`}>How it Works</Nav.Link>
                                    {/* <Nav.Link href='#features' >Features</Nav.Link> */}
                                    <NavDropdown title="Features"  className={`${styles.navldropdownHeader}`} id="navbarScrollingDropdown">
                                        <NavDropdown.Item href="#action/3.1"  className={`${styles.dropdownlink}`}>Market Place</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.2"  className={`${styles.dropdownlink}`}>Reference/Affiliates</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.3" className={`${styles.dropdownlink}`}>Escrow Payments</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.4" className={`${styles.dropdownlink}`}>File Management</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.4" className={`${styles.dropdownlink}`}>Server Management</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.4" className={`${styles.dropdownlink}`}>Pricing Calculator</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.4" className={`${styles.dropdownlink}`}>SiteULL</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.4" className={`${styles.dropdownlink}`}>Branch</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.4" className={`${styles.dropdownlinkallfeature}`}>All Features</NavDropdown.Item>
                                        {/* <NavDropdown.Item href="#action/3.4">Integrations</NavDropdown.Item> */}
                                        </NavDropdown>
                                    <Nav.Link as={Link} to={'/pricing'} className={`${styles.navlink}`}>Pricing</Nav.Link>
                                    <Nav.Link href='#enterprise' className={`${styles.navlink}`}>Enterprise</Nav.Link>
                                    <Nav.Link href='#developer' as={Link} to={'/faq'} className={`${styles.navlink}`}>FAQ</Nav.Link>
                                      <NavDropdown title="Learn" id="basic-nav-dropdown" className={`${styles.navldropdownHeader}`} navbarScroll>
                                        <NavDropdown.Item href="#action/3.1" className={`${styles.dropdownlink}`}>ULLWeb Academy</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.2" className={`${styles.dropdownlink}`}>Growth Blog</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.3" className={`${styles.dropdownlink}`}>Guides</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.4" className={`${styles.dropdownlink}`}>Use Cases</NavDropdown.Item>
                                        </NavDropdown>
                                    <Nav.Link href='#project' className={`${styles.navlink}`}>ProjectOn<img src={naija} alt='nigeria national flag' /></Nav.Link>
                                </Nav>
                                <Nav className={`ms-lg-auto ${styles.btnheaderG}`} >
                                    <ButtonGroup className={`d-flex g-3`}>
                                        <Button variant='primary' className={`me-2 ${styles.btn2}`}>Get Started Free <img src={arrow} /></Button>    
                                        <Button variant='primary' className={`${styles.btn3}`}>LOG IN</Button>                                        

                                    </ButtonGroup>
                                </Nav>
                            </Navbar.Collapse>
                        </Container>

                    </Navbar>
                
                </Col>
                
            </Row>
        </Container>

    </div>
}